class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class AddOnProducts extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.url = this.dataset.url;
    this.subtotalElement = document.querySelector('.totals__subtotal-value');
  }

  connectedCallback() {
    fetch(this.url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('[data-add-on-container]');
      const recommendationList = html.querySelector('[data-add-on-items]');

      if (recommendations && recommendations.innerHTML.trim().length && recommendationList) {
        this.container.innerHTML = recommendations.innerHTML;
        this.bind();
      } else {
        this.container.innerHTML = '';
      }
    })
    .catch(e => {
      console.error(e);
    });
  }

  bind() {
    const addOnItems = this.querySelectorAll('.add-on-cart-item--selectable');
    addOnItems.forEach((item) => {
      item.addEventListener('click', this.toggleAddonProduct.bind(this));
    });
  }

  toggleAddonProduct(event) {
    const item = event.target.closest('.add-on-cart-item');

    if (!item) {
      return;
    }

    const hiddenInput = item.querySelector('input[type="hidden"]');

    if (hiddenInput.disabled) {
      hiddenInput.disabled = false;
      item.setAttribute('aria-pressed', true);
      item.classList.add('add-on-cart-item--is-selected');
      const formData = {
        items: [{
         id: hiddenInput.value,
         quantity: 1
        }]
       };
       fetch(window.Shopify.routes.root + 'cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
         return response.json();
       })
       .then(json => {
        this.updateTotals();
       })
       .catch((error) => {
         console.error('Error:', error);
       })
       // Extend - update cart
      .finally(() => {
        document.dispatchEvent(new Event('extend.cart-updated'));
      });
      // Extend - end Extend code

    } else {
      hiddenInput.disabled = true;
      item.setAttribute('aria-pressed', false);
      item.classList.remove('add-on-cart-item--is-selected');

      const formData = {
        id: hiddenInput.value,
        quantity: 0
       };
      
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.updateTotals();
       })
      .catch((error) => {
        console.error('Error:', error);
      })
      // Extend - update cart
      .finally(() => {
        document.dispatchEvent(new Event('extend.cart-updated'));
      });
      // Extend - end Extend code
    }
  }

  updateTotals() {
    fetch(`${routes.cart_url}`)
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const updatedFooterContent = getSectionInnerHTML(state, '#CartDrawer');
      document.getElementById('CartDrawer').innerHTML = updatedFooterContent;
    }).catch((error) => {
      console.log(error);
    });
  }
}

customElements.define('add-on-products', AddOnProducts);

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}
